import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from 'shared-components';
import { CultivosService } from "../../../../../services/cultivos.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-cultivo-marca-new-edit',
    templateUrl: './new-edit.component.html'
})
export class CMNewEditComponent implements OnInit {
    private _cultivoMarca;
    public newEditForm;
    public showError: boolean;
    public showApiError: boolean; // evitar mostrar la clase de error en inputs si falla el getById
    public mensajes = new Array<Message>();
    public errorMsg = '';
    public disable = false;
    public marcas;

    public _toDelete: any;
    public _editable: boolean;

    private _cultivoId;
    private _marcaId;
    private _filters;

    public deleteModal = false;
    public errorAddMarca = false;

    public cultivoDesignacion;s
    public newModalDesignacion = false;

    public disabled: Subject<boolean> = new Subject();

    @Input() cultivoMarca?;
    @Input() cultivoId;
    @Input() desFinca;
    @Input() aforoDisponible;
    @Input() paisId;
    @Input() denominacionId;
    @Input() campanyaHabilitada;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.get('marca').enable();
                this.newEditForm.get('aforo').enable();
                this.disabled.next(false);
            } else {
                this.newEditForm.disable();
                this.newEditForm.patchValue({
                    marcaId: this.marcas.find(x => x.id === this.cultivoMarca.marcaId),
                    aforo: this.cultivoMarca.aforo,
                    porcentajeAforo: this.cultivoMarca.porcentajeSobreAforoCultivo
                });
                this.disabled.next(true);
            }
        }
    }

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _cultivosService: CultivosService,
        private readonly _sessionContext: SessionContextService,
        private readonly _translate: TranslateService,

    ) {}

    ngOnInit(){
        this.newEditForm = this._fb.group({
            marca: ['', Validators.required],
            aforo: ['', Validators.required],
            porcentajeAforo: [{value: this.desFinca, disabled: true}]
        });


        let promises: Promise<any>[] = [];
        promises.push(this.getMarcasByPaisDenominacion());

            //// Missing return was here
        Promise.all(promises).then(
            (values) => {
            console.log("Promise all finished: " + values);

            this._spinnerService.hideSpinner();
            if (this.cultivoMarca) {
                this.newEditForm.patchValue({
                    marca: this.marcas.find(x => x.id === this.cultivoMarca.marcaId),
                    aforo: this.cultivoMarca.aforo,
                    porcentajeAforo: this.cultivoMarca.porcentajeSobreAforoCultivo
                });
                this.newEditForm.disable();
                this.disabled.next(true);
            }
        }
        );
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public getMarcasByPaisDenominacion(): Promise<any> {

        this._filters = {
            paisId: this.paisId,
            denominacionId: this.denominacionId
        };

        return new Promise((resolve,reject) => {
            this._spinnerService.showSpinner();
            this._cultivosService.getMarcasByPaisDenominacion(this._filters).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                this.marcas = resp.lista;
                setTimeout(resolve,1);
            }, (error) => {
                this.showApiError = true;
                if (error.status === 420) {
                    this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
                } else {
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            });
          });
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.cultivoMarca) {

            if (this.aforoDisponible < this.newEditForm.get('aforo').value) {
                this.errorMsg = this._translate.instant('ApiErrors.cantidadExcedida');
                this.errorAddMarca = true;
                return;
            }

            this._cultivoMarca = {
                cultivoId: this.cultivoId,
                marcaId: this.newEditForm.get('marca').value.id,
                aforo: this.newEditForm.get('aforo').value
            };
            this._spinnerService.showSpinner();
            this._cultivosService.createCultivoMarca(this._cultivoMarca).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp) {
                    this._editable = false;
                    this.refresh.emit(true);
                    this.disabled.next(true);
                    this.newEditForm.disable();
                    this.pushMessage.emit('global.success.itemCreated');
                } else {
                    this.showError = true;
                    this.pushMessage.emit('global.error.noResponse');
                }
            },
            (error) => {
                if (error.status === 420) {
                    switch (error.error.ApiErrorCode){
                        case 6031:
                            this.errorMsg = this._translate.instant('ApiErrors.noDuplicarMarca');
                            break;
                        case 6036:
                            this.errorMsg = this._translate.instant('ApiErrors.campanyaHabilitada');
                            break;
                    }
                }
                this.errorAddMarca = true;
            });
        } else if (this.newEditForm.valid && this.cultivoMarca) {
            this._cultivoMarca = {
                cultivoId: this.cultivoMarca.cultivoId,
                marcaId: this.newEditForm.get('marca').value.id,
                aforo: this.newEditForm.get('aforo').value
            };
            this._spinnerService.showSpinner();
            this._cultivosService.updateCultivoMarca(this._cultivoMarca).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this.disabled.next(true);
                    this.newEditForm.disable();
                    this.refresh.emit(true);
                    this.pushMessage.emit('global.success.itemUpdated');
                },
                (error) => {
                    if (error.status === 420) {
                        switch (error.error.ApiErrorCode){
                            case 6032:
                                this.errorMsg = this._translate.instant('ApiErrors.cantidadExcedida');
                        }
                    }
                    this.errorAddMarca = true;
                }
            );
        }
    }

    public cancel() {
        if (this.cultivoMarca != null) {
            this.close.emit(true);
            this.refresh.emit(true);
        } else {
            this.editableChanged.emit();
        }
    }

    public closeModal() {
        this.deleteModal = false;
        this.errorAddMarca = false;
        this._toDelete = '';
    }

    public edit(cultivoMarca) {
        this.newEditForm.get('marca').enable();
        this.newEditForm.get('aforo').enable();
        this.disabled.next(true);
        this.editableChanged.emit(cultivoMarca);
    }

    public askDelete(cultivoMarca) {
        this._cultivoId = cultivoMarca.cultivoId;
        this._marcaId = cultivoMarca.marcaId;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._cultivosService.deleteCultivoMarca(this._cultivoId, this._marcaId).toPromise().finally(() => {
        }).then(() => {
          this.closeModal();
          this.refresh.emit(true);
          this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }

    public getRolePermission() {
        let disabled = false;

        if (this.role === 'Administrador') {
            disabled = false;
        } else if (this.role === 'Auditor') {
            disabled = false;
        } else if (this.role === 'Supervisor') {
            disabled = true;
        }

        return disabled;
    }


    public designarCultivo(cultivoMarca) {
      this._spinnerService.showSpinner();
      this._cultivosService.getCultivoFinca(this.cultivoId).toPromise().finally(() => {
        this._spinnerService.hideSpinner();
      }).then((resp) => {
        console.log(resp);
        console.log(cultivoMarca);
        this.cultivoDesignacion = {
          id: resp.id,
          desFinca: resp.des,
          desDenominacionCampanya: resp.desDenominacionCampanya,
          paisIdCampanya: resp.paisIdCampanya,
          marcaId: cultivoMarca.marcaId,
          superficie: resp.superficie,
          nPlantas: resp.nPlantas,
          aforo: cultivoMarca.aforo,
          aforoDisponible: cultivoMarca.aforoDisponible
        };
        this.newModalDesignacion = true;
      });
    }

    public refreshDesignacion(value) {
      this.newModalDesignacion = false;
    }
}
